export default {
  data() {
    const checkPhoneNumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!/^1[3456789]\d{9}$/.test(this.addUserForm.phoneNumber)) {
        callback(new Error("手机号码格式有误，请验证手机号码!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        realName: [
          { required: false, message: "请输入用户名", trigger: "blur" },
        ],
        account: [{ required: false, message: "请输入账号", trigger: "blur" }],
        phoneNumber: [
          { validator: checkPhoneNumber, trigger: "blur", required: false },
        ],
      },
      UtypeOptions: [],
    };
  },

  methods: {}
};
